import { render, staticRenderFns } from "./InkasJouBrigCard.vue?vue&type=template&id=f5ba895a&scoped=true&"
import script from "./InkasJouBrigCard.vue?vue&type=script&lang=js&"
export * from "./InkasJouBrigCard.vue?vue&type=script&lang=js&"
import style0 from "./InkasJouBrigCard.vue?vue&type=style&index=0&id=f5ba895a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ba895a",
  null
  
)

export default component.exports